<div class="snackbar" [class.show]="showSnackbar" [ngClass]="snackbarClass">
    <span>{{message}}</span>
</div>
  
